'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

var Capitalize = function Capitalize(string) {
  var words = string.split(' ');
  var capitalizedWords = words.map(function (word) {
    return capitalizeFirstLetter(word);
  });
  return capitalizedWords.join(' ');
};

exports.default = Capitalize;